import React from "react";
import JsGravatar from 'js-gravatar';

const Gravatar = ({ email, size = 200, className }) => {
  const gravUrl = JsGravatar({email: email, md5Hash: "default", size: size, defaultImage: "mp"}).replace(/^http.?:/,"https:")
  return <img className={className} src={gravUrl || gravatarUrl(email, {size: size})} alt="Gravatar" />;
};

export default Gravatar
